<template>
  <f7-page name="aktualne-pocasie" @page:init="onPageInit" @page:beforeout="onPageBeforeOut" @page:beforeremove="onPageBeforeRemove">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Aktuálne počasie</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-toolbar tabbar bottom>
      <f7-link tab-link="#tab-ap-mesto" tab-link-active>Mesto</f7-link>
      <f7-link tab-link="#tab-ap-mapa" >Mapa</f7-link>
    </f7-toolbar>

    <f7-tabs class="wh-100">
      <f7-tab id="tab-ap-mesto" class="wh-100" @tab:show="onMestoTabShow($event)" tab-active>
        <f7-block strong class="no-padding no-margin no-border-top">
          <template v-if="isStationsLoaded">
            <f7-list class="ss-list">
              <f7-list-item class="aktualne-pocasie-ss-list"
                            title="Stanica:"
                            smart-select
                            :smart-select-params="{openIn: 'popup', scrollToSelectedItem:true, closeOnSelect: true, pageTitle:'Vyberte stanicu', popupCloseLinkText:'Návrat', searchbar: {  removeDiacritics:true, customSearch: true, on: { search: searchFromBeginning }, }, searchbarPlaceholder: 'Hľadať...'}">
                <select class="s3" name="station" v-model="selectedStationId" @change="onSelectCity($event)">
                  <option v-for="(value, key) in stations" :key="key" :value="value.station_id">{{ value.station_name }}</option>
                </select>
                <div slot="root-start" class="float-left" style="margin: 3px;" v-if="isGeolocationEnabled">
                  <f7-button @click="selectStationByLocation" class="text-color-black" icon-f7="placemark_fill"></f7-button>
                </div>
              </f7-list-item>
            </f7-list>

            <aktualne-pocasie-mesto v-if="isDataLoaded" :station-data="stationData" :station-meta="stationMeta" ></aktualne-pocasie-mesto>

          </template>
        </f7-block>
      </f7-tab>
      <f7-tab id="tab-ap-mapa" class="wh-100" @tab:show="onMapTabShow($event)">
          <aktualne-pocasie-mapa :mapChanged="mapTabChanged" :reloadInvoked="reloadInvoked"></aktualne-pocasie-mapa>
      </f7-tab>
    </f7-tabs>


  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import searchMixin from "../js/mixin";
import AktualnePocasieMapa from "./aktualne-pocasie-mapa";
import AktualnePocasieMesto from "../components/aktualne-pocasie-mesto";
import geoLocationMixin from "../js/geoLocationMixin";


export default {
  components: {
    AktualnePocasieMapa,
    AktualnePocasieMesto,
  },
  mixins: [searchMixin,
    geoLocationMixin],
  data: function () {
    // var productId = this.$f7route.params.id; // ziskanie parametra z url
    return {
      // products: this.$f7.data.products, // ziskanie udajov z globalneho data
      stations: [],
      stationData: {},
      selectedStationId: null,
      isStationsLoaded: false,
      isDataLoaded: false,
      lastUpdated: 0,
      tCheckInterval: null,
      mapTabChanged: 0,
      reloadInvoked: 0,
    };
  },
  computed : {
    stationMeta: function () {
      return this.stations.find(station => parseInt(station.station_id) === parseInt(this.selectedStationId));
    },


  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');

  },
  updated() {
    if (this.selectedStationId === null && this.stations.length > 0) {
      this.$f7.smartSelect.get('.aktualne-pocasie-ss-list .smart-select').open()
    }
  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        this.reloadInvoked = Math.random();
        let cached_stations = self.$ls.get('actual_weather_stations');
        if (cached_stations !== null) {
          self.stations = cached_stations;
          self.selectedStationId = this.$ls.get('actual_weather_station_id');
          self.isStationsLoaded = true;
          self.loadStationData();
          self.$f7.dialog.close();
        } else {

          self.$f7.dialog.preloader('Načítavam...');

          Axios.get(SHMUconf.API_BASE_URL + 'meteo/getactualweatherstations', {
            crossDomain: true,
            cache: false,
          })
              .then((response) => {
                if (!response.data.error) {
                  self.stations = response.data;
                  self.selectedStationId = this.$ls.get('actual_weather_station_id');
                  self.isStationsLoaded = true;
                  self.$ls.set('actual_weather_stations', self.stations, 24 * 60 * 60 * 1000); // 1 den
                  self.loadStationData();
                } else {
                  self.$f7.dialog.alert('Nepodarilo sa načítať zoznam staníc aktuálneho počasia', 'Nastala chyba');
                }
                self.$f7.dialog.close();

              }).catch((error) => {
            self.$f7.dialog.close();
            self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
          });
        }
      }

    },
    onSelectCity(event) {
      this.selectedStationId = parseInt(event.target.value);
      this.loadStationData();
      this.$ls.set('actual_weather_station_id', this.selectedStationId);
    },
    loadStationData() {
      const self = this;

      if (this.selectedStationId === null) {
        // ak nie je vybrana stanica, nic nerobime, v updated funkcii sa otvori vyber stanic
      } else {
        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'meteo/getactualweatherdata?station=' + this.selectedStationId, {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.stationData = response.data[0];
                self.isDataLoaded = true;
                self.lastUpdated = self.$moment().unix();

                // clearInterval(this.tCheckInterval);
                // this.tCheckInterval = setInterval(this.checkLastUpdated, 60*1000); // overujem kazdu minutu

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať aktuálne údaje k stanici', 'Nastala chyba');
              }
              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }

    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) > 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    onMapTabShow(e) {
      this.mapTabChanged = Math.random();
    },
    onMestoTabShow(e) {

    },
    onPageBeforeOut() {
      const self = this;
      // console.log('onPageBeforeOut');
      // Close opened sheets on page out
      self.$f7.popover.close();
    },
    onPageBeforeRemove() {
      const self = this;
      //   console.log('onPageBeforeRemove');
      // Destroy sheet modal when page removed
      if (self.popover) self.popover.destroy();
    },
    selectStationByLocation() {
      if (this.isGeolocationEnabled) {
        this.getGeoLocation(this.onLocationFoundAndSelectFirst, this.onLocationError)
      }
    },
    onLocationFoundAndSelectFirst(e) {
      this.currentLocation = e.coords;

      if (this.currentLocation !== null) {
        for (let i = 0; i < this.stations.length; i++) {
          this.stations[i]["distance"] = this.calculateDistance(
              this.currentLocation.latitude, this.currentLocation.longitude,
              this.stations[i]["gps_lat"], this.stations[i]["gps_lon"],"K").toFixed(2);
        }

        this.stations.sort(function(a, b) {
          return a.distance - b.distance;
        });

        this.selectedStationId = parseInt(this.stations[0].station_id);
        this.loadStationData();
        this.$ls.set('actual_weather_station_id', this.selectedStationId);
        this.$f7.smartSelect.get('.aktualne-pocasie-ss-list .smart-select').setValue(this.selectedStationId);

      }
    },
    onLocationError(e) {
      this.locationError(this, e);
    },


  }

};
</script>
